import {
  GET_CUSTOMER,
  GET_CUSTOMER_FAIL,
  GET_CUSTOMER_SUCCESS,
  GET_CUSTOMER_DETAILS,
  GET_CUSTOMER_DETAILS_FAIL,
  GET_CUSTOMER_DETAILS_SUCCESS,
  ADD_NEW_CUSTOMER,
  ADD_CUSTOMER_SUCCESS,
  ADD_CUSTOMER_FAIL,
  UPDATE_CUSTOMER,
  UPDATE_CUSTOMER_SUCCESS,
  UPDATE_CUSTOMER_FAIL,
  DELETE_CUSTOMER,
  DELETE_CUSTOMER_SUCCESS,
  DELETE_CUSTOMER_FAIL,
  RESET_CUSTOMER_STATE,
  GET_CUSTOMER_SELECT_LISTING,
  GET_CUSTOMER_SELECT_LISTING_SUCCESS,
  GET_CUSTOMER_SELECT_LISTING_FAIL,
  EXPORT_CUSTOMER,
  EXPORT_CUSTOMER_SUCCESS,
  EXPORT_CUSTOMER_FAIL,
  ADD_CUSTOMER_POINTS,
  ADD_CUSTOMER_POINTS_SUCCESS,
  ADD_CUSTOMER_POINTS_FAIL,
  ADD_CUSTOMER_VOUCHERS,
  ADD_CUSTOMER_VOUCHERS_SUCCESS,
  ADD_CUSTOMER_VOUCHERS_FAIL,
  RESET_CUSTOMER_ATTACHMENT_STATE,
} from "./actionTypes";

export const getCustomer = ({length, page, keyword, status, sort, sort_by}) => ({
  type: GET_CUSTOMER,
  payload: {length, page, keyword, status, sort, sort_by},
});

export const getCustomerSuccess = customer => ({
  type: GET_CUSTOMER_SUCCESS,
  payload: customer,
});

export const getCustomerFail = error => ({
  type: GET_CUSTOMER_FAIL,
  payload: error,
});

export const getCustomerSelectListing = () => ({
  type: GET_CUSTOMER_SELECT_LISTING
});

export const getCustomerSelectListingSuccess = customer => ({
  type: GET_CUSTOMER_SELECT_LISTING_SUCCESS,
  payload: customer,
});

export const getCustomerSelectListingFail = error => ({
  type: GET_CUSTOMER_SELECT_LISTING_FAIL,
  payload: error,
});

export const getCustomerDetails = ({ id, point_sort, point_order, voucher_sort, voucher_order }) => ({
  type: GET_CUSTOMER_DETAILS,
  payload: { id, point_sort, point_order, voucher_sort, voucher_order },
});

export const getCustomerDetailsSuccess = customer => ({
  type: GET_CUSTOMER_DETAILS_SUCCESS,
  payload: customer,
});

export const getCustomerDetailsFail = error => ({
  type: GET_CUSTOMER_DETAILS_FAIL,
  payload: error,
});

//add 
export const addNewCustomer = customer => ({
  type: ADD_NEW_CUSTOMER,
  payload: customer,
});

export const addCustomerSuccess = customer => ({
  type: ADD_CUSTOMER_SUCCESS,
  payload: customer,
});

export const addCustomerFail = error => ({
  type: ADD_CUSTOMER_FAIL,
  payload: error,
});

//update 
export const updateCustomer = ({ id, customer }) => ({
  type: UPDATE_CUSTOMER,
  payload: { id, customer },
});

export const updateCustomerSuccess = customer => ({
  type: UPDATE_CUSTOMER_SUCCESS,
  payload: customer,
});

export const updateCustomerFail = error => ({
  type: UPDATE_CUSTOMER_FAIL,
  payload: error,
});

//delete 
export const deleteCustomer = ({ id }) => ({
  type: DELETE_CUSTOMER,
  payload: { id },
});

export const deleteCustomerSuccess = customer => ({
  type: DELETE_CUSTOMER_SUCCESS,
  payload: customer,
});

export const deleteCustomerFail = error => ({
  type: DELETE_CUSTOMER_FAIL,
  payload: error,
});

//export
export const exportCustomer = (payload) => ({
  type: EXPORT_CUSTOMER,
  payload: payload,
});

export const exportCustomerSuccess = customer => ({
  type: EXPORT_CUSTOMER_SUCCESS,
  payload: customer,
});

export const exportCustomerFail = error => ({
  type: EXPORT_CUSTOMER_FAIL,
  payload: error,
});

//update 
export const addCustomerPoints = ({ id, customer }) => ({
  type: ADD_CUSTOMER_POINTS,
  payload: { id, customer },
});

export const addCustomerPointsSuccess = customer => ({
  type: ADD_CUSTOMER_POINTS_SUCCESS,
  payload: customer,
});

export const addCustomerPointsFail = error => ({
  type: ADD_CUSTOMER_POINTS_FAIL,
  payload: error,
});

//update 
export const addCustomerVoucher = ({ id, customer }) => ({
  type: ADD_CUSTOMER_VOUCHERS,
  payload: { id, customer },
});

export const addCustomerVoucherSuccess = customer => ({
  type: ADD_CUSTOMER_VOUCHERS_SUCCESS,
  payload: customer,
});

export const addCustomerVoucherFail = error => ({
  type: ADD_CUSTOMER_VOUCHERS_FAIL,
  payload: error,
});

//reset
export const resetCustomerState = () => {
  return {
    type: RESET_CUSTOMER_STATE,
  }
}

//reset attachment
export const resetCustomerAttachmentState = () => {
  return {
    type: RESET_CUSTOMER_ATTACHMENT_STATE,
  }
}


